export const SORT_BY_DATE = "SORT_BY_DATE";
export const SORT_BY_PRIORITY = "SORT_BY_PRIORITY";
export const CLEAR_FILTER = "CLEAR_FILTER";
